import React, { ReactNode } from 'react';
import s from './FixedWrapper.module.scss';

export function FixedWrapper({ children }: { children: ReactNode }) {
  return <div className={s.FixedWrapper}>{children}</div>;
}
